import { Create, SimpleForm, TextInput, required, ReferenceInput, SelectInput, useNotify, useRedirect } from 'react-admin';
import { useLocation } from 'react-router-dom';

export const WorkflowCategoryCreate = () => {
  const location = useLocation();
  const notify = useNotify();
  const redirect = useRedirect();

  const workflowId = location.state?.record?.workflowId;

  const onSuccess = () => {
    notify('Category created');
    if (workflowId) {
      redirect(`/workflows/${workflowId}/categories`);
    } else {
      redirect('/workflows');
    }
  };

  return (
    <Create mutationOptions={{ onSuccess }} title="Create Workflow Category">
      <SimpleForm defaultValues={{ workflowId }}>
        <TextInput source="name" validate={required()} fullWidth />
        <ReferenceInput source="workflowId" reference="workflows">
          <SelectInput optionText="name" disabled={!!workflowId} />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};
